export enum SideCardItemMode {
  Details = 'detailsMode',
  EditSingle = 'editSingleMode',
  EditSeries = 'editSeriesMode',
  Create = 'createMode',
  TableOnly = 'tableOnlyMode'
}

export type SideCardModes =
  | {
      mode: SideCardItemMode.Create
    }
  | {
      mode: SideCardItemMode.Details | SideCardItemMode.EditSingle | SideCardItemMode.EditSeries
      itemId: string
      taskPlantId?: string
      source?: string
      externalId?: string
    }

export type ViewMode =
  | SideCardModes
  | {
      mode: SideCardItemMode.TableOnly
    }
